import React, { Component } from 'react'
const DemoComponent=React.forwardRef((props,ref)=>{
    function testclick(){
       ref.current.focus();
    }
return(
    <>
    <button onClick={testclick}>Click</button>
    </>
)
})
export class ForwardRefComponent extends Component {
    constructor(props) {
        super(props)
        this.elevatorRef=React.createRef();
        this.state = {

        }
    }
    
    render() {
        return (
             <div>
            <h2>Welcome to Elevator Ordering Screen...</h2>
            <p>
            <label>Elevator Name : <input ref={this.elevatorRef} type="text"></input></label>
            </p>
            <p>
            <label>Elevator Speed : <input  type="text"></input></label>
            </p>
            <p>
             <label>Elevator Load : <input type="text"></input></label>
             </p>
            <Summary Innerref={this.elevatorRef}></Summary>
            <DemoComponent ref={this.elevatorRef}></DemoComponent>
            <br/>
            <br/>
            <TestComponent></TestComponent>
            </div>            
        )
    }
}
class Summary extends React.Component{
    constructor(props){  
      super(props);  
    }
    focusinput=()=>{
        this.props.Innerref.current.focus();    }
     render(){  
      return (  
        <div onClick={this.focusinput}>  
          <h2>Summary Details...</h2>  
          <p >  
            <label>Elevator Name : <b>Name - 1</b></label>    
          </p>  
          <p>  
            <label>Elevator Speed : <b>10 m/s</b></label> 
          </p>  
          <p>  
            <label>Elevator Load : <b>550 Kg</b></label>  
          </p>           
          </div>  
        
      );  
    }  
  }
  function TestComponent(){
      let testref=null;
    function handleClick() {
        testref.focus()
        }
  
    return (
  
      <div>
  
        <input type="text" ref={e=>testref=e} />
  
        <input type="button" value="Focus the text input" onClick={handleClick}/>
  
      </div>
  
    );
  
  }
export default ForwardRefComponent
